export const getFilteredAppointments = (
  appointments,
  selectedAppointmentType
) => {
  if (!selectedAppointmentType) return appointments

  return appointments.filter(
    appointment =>
      appointment?.appointmentType?.id === selectedAppointmentType.id
  )
}
